export class filterItem {
  field: string;
  value: string;
}
